import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {CustomersDialogService} from "../../services/customers-dialogs-service.service";
import {CustomerService} from "../../services/customers-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class customerAddressesViewCtrl implements IController {

  customer: any;

  /* @ngInject */
  constructor(private $log, private $q: IQService, private confirmDialogService: ConfirmDialogService,
              private customersDialogService: CustomersDialogService, private customerService: CustomerService) {
  }

  $onInit() {

  }

  onAddAddress(event) {
    this.customersDialogService.addAddress(event)
      .then((address) => {
        this._addAddress(address);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDefaultAddressChange(address) {
    const currentDefaultAddressId = angular.copy(this.customer.defaultAddressId);

    this.customer.defaultAddressId = undefined;
    this.customerService.updateDefaultAddress(this.customer.id, address.id)
      .then((updatedDefaultAddress) => {
        this.customer.defaultAddressId = updatedDefaultAddress.defaultAddressId;
      })
      .catch((error) => {
        this.$log.info('Failed to update default address', error);
        this.customer.defaultAddressId = currentDefaultAddressId;
      })
  }

  onEditAddress(address, event) {
    const originalAddress = angular.copy(address);
    this.customersDialogService.editAddress(address, event)
      .then((addressForUpdate) => {
        addressForUpdate.id = originalAddress.id;
        const customerCopy = angular.copy(this.customer);
        customerCopy.addresses = _
          .chain(this.customer.addresses)
          .filter((a) => {
            return a.id !== address.id;
          })
          .concat([addressForUpdate])
          .value();

        this._updateAddress(customerCopy.id, customerCopy, originalAddress);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRemoveAddress(address, event) {
    this.confirmDialogService.confirm('Remove Address', 'Are you sure you want to delete this address?', event)
      .then(() => {
        this._deleteAddress(this.customer.id, address);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _addAddress(address) {
    this.customerService.addAddress(this.customer.id, address)
      .then((createdAddress) => {
        this.customer.addresses.push(createdAddress);
      })
  }

  private _updateAddress(customerId, customer, originalAddress) {
    this.customerService.updateAddress(customerId, customer, originalAddress)
      .then((updatedCustomer) => {
        this.customer = updatedCustomer;
      })
  }

  private _deleteAddress(customerId, address) {
    this.customerService.deleteAddress(customerId, address.id, address)
      .then((deletedAddress) => {
        this.customer.addresses = _.filter(this.customer.addresses, (a) => {
          return a.id !== address.id
        });
        return this.customer.defaultAddressId === address.id ?
          this.customerService.getDefaultAddress(this.customer.id) :
          this.$q.when();
      })
      .then((defaultAddress) => {
        if (defaultAddress) {
          this.customer.defaultAddressId = defaultAddress.id;
        }
      })
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerAddressesView', {
    bindings: {
      customer: '<'
    },
    template: require('./customer-addresses-view.html').default,
    controller: customerAddressesViewCtrl
  });
